import { Box, Flex } from '@modusign/design-system';
import React, { useEffect, useRef, useState } from 'react';

interface SearchInputProps {
  searchKeyword: string;
  placeholder?: string;
  onChange: (value: string) => void;
}

const InnerSearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ searchKeyword, placeholder, onChange }, ref) => {
    const MIN_INPUT_WIDTH = placeholder ? 180 : 75;

    const widthTrackerRef = useRef<HTMLDivElement>(null);

    const [width, setWidth] = useState(MIN_INPUT_WIDTH);

    useEffect(() => {
      setWidth(Math.max(widthTrackerRef.current?.clientWidth ?? 0, MIN_INPUT_WIDTH));
    }, [MIN_INPUT_WIDTH, placeholder, searchKeyword]);

    return (
      <Flex flexDirection="column" width={width}>
        <Box
          as="input"
          autoFocus
          flex="1 0 auto"
          m={1}
          placeholder={placeholder}
          ref={ref}
          type="text"
          value={searchKeyword}
          width="100%"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
        />
        <Box
          aria-hidden="true"
          flex="0 1 0"
          height={0}
          overflowY="hidden"
          ref={widthTrackerRef}
          whiteSpace="nowrap"
          width="fit-content"
        >
          {searchKeyword}
        </Box>
      </Flex>
    );
  }
);

export default InnerSearchInput;
